import { setDefaultStrategy } from './environment.js';

setDefaultStrategy(fetch);

export * from './shared.js';
